"use client";

import React from "react";

interface EmojiProps {
	className?: string;
	label: string;
	symbol: string;
}

export const EmojiFromCode = React.memo((props: EmojiProps) => (
	<span className={props.className} role="img" aria-label={props.label}>
		{String.fromCodePoint(Number.parseInt(props.symbol, 16))}
	</span>
));

EmojiFromCode.displayName = "EmojiFromCode";
